import React from "react";
import { MessageSquarePlus, MessageSquareText, ListChecks, UserCog, Headphones, Tag } from "lucide-react";

const Node = ({ icon: Icon, title, tone = "default" }) => {
  const tones = {
    default: "bg-white border-slate-200 text-slate-800",
    start: "bg-[var(--et-navy)] border-transparent text-white",
    green: "bg-[#DCF8C6] border-[#bfe7a4] text-slate-800",
  };
  return (
    <div className={`inline-flex items-center gap-2 rounded-xl border px-3 py-2 shadow-sm ${tones[tone]}`}>
      <span className={`flex h-7 w-7 items-center justify-center rounded-lg ${tone === "start" ? "bg-white/10 text-[var(--et-accent)]" : tone === "green" ? "bg-white/60 text-green-700" : "bg-[rgba(37,99,235,0.1)] text-[var(--et-primary)]"}`}><Icon className="h-3.5 w-3.5" /></span>
      <span className="text-[12px] font-semibold whitespace-nowrap">{title}</span>
    </div>
  );
};

const Down = () => <div className="my-1.5 h-4 w-px bg-slate-300" />;

/**
 * Node-based visual flow builder illustration (responsive: vertical on mobile).
 */
export const FlowBuilderMock = () => {
  return (
    <div className="et-card p-6 sm:p-8">
      <div className="flex items-center justify-between mb-6">
        <div className="inline-flex items-center gap-2 text-sm font-semibold text-slate-700"><ListChecks className="h-4 w-4 text-[var(--et-primary)]" /> Visual Flow Builder</div>
        <span className="rounded-full bg-slate-100 px-2.5 py-1 text-[10px] font-semibold text-slate-500">Demo</span>
      </div>

      <div className="flex flex-col items-center">
        <Node icon={MessageSquarePlus} title="New Enquiry" tone="start" />
        <Down />
        <Node icon={MessageSquareText} title="Welcome Message" tone="green" />
        <Down />
        <Node icon={ListChecks} title="Select Requirement" />

        {/* Branch connectors */}
        <div className="relative mt-1.5 w-full max-w-md">
          <div className="mx-auto h-4 w-px bg-slate-300" />
          <div className="flex justify-between">
            <div className="flex-1 flex flex-col items-center">
              <div className="h-4 w-px bg-slate-300" />
              <Node icon={Tag} title="Sales" />
            </div>
            <div className="flex-1 flex flex-col items-center">
              <div className="h-4 w-px bg-slate-300" />
              <Node icon={Headphones} title="Support" />
            </div>
            <div className="flex-1 flex flex-col items-center">
              <div className="h-4 w-px bg-slate-300" />
              <Node icon={Tag} title="Pricing" />
            </div>
          </div>
          <div className="absolute left-[16.6%] right-[16.6%] top-4 h-px bg-slate-300" />
        </div>

        <Down />
        <Node icon={UserCog} title="Assign Agent / Automation" tone="start" />
      </div>
    </div>
  );
};
